import { Code2, Github, Linkedin, Mail } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: Github,
      href: 'https://github.com/Paras1209',
      label: 'GitHub',
    },
    {
      icon: Linkedin,
      href: 'https://www.linkedin.com/in/dtu-paras-kanojia/',
      label: 'LinkedIn',
    },
    {
      icon: Mail,
      href: 'mailto:kanojiaparas582@gmail.com',
      label: 'Email',
    },
  ];

  return (
    <footer className="relative z-10 border-t border-white/15">
      <div className="px-5 sm:px-8 md:px-12 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <Code2 size={20} strokeWidth={1.5} className="text-white/60" />
            <span className="text-sm text-white/60">paras</span>
          </div>

          {/* Copyright */}
          <p className="text-xs text-white/40 order-last sm:order-none">
            {currentYear} Paras Kanojia. Built with React & Tailwind.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target={link.href.startsWith('mailto') ? undefined : '_blank'}
                rel={link.href.startsWith('mailto') ? undefined : 'noopener noreferrer'}
                className="p-2 text-white/40 hover:text-white transition-colors"
                aria-label={link.label}
              >
                <link.icon size={18} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
